// extracted by mini-css-extract-plugin
export var chip = "_b4-0";
export var filterDropdown = "_b4-5";
export var filterItem = "_b4-6";
export var icon = "_b4-1";
export var removeButton = "_b4-3";
export var removeIcon = "_b4-4";
export var separator = "_b4-2";